<template>
  <section style="height:100%">
    <v-container fluid grid-list-md class="pa-0" style="height:100%">
      <v-flex xs12 style="height:100%;">
        <v-card
          class="mx-auto contenedor-persona"
          color="grey lighten-4"
          elevation="4"
          style="height:100%; display:flex; flex-direction:column; justify-content:space-between"
        >
          <v-card-text class="pt-1 pb-0 contenedor-foto">
            <v-avatar :color="foto ? '#FFF' : 'light-blue darken-4'" size="75">
              <v-img
                v-if="foto"
                :aspect-ratio="16 / 9"
                :src="foto"
                max-height="150"
                max-width="150"
                min-height="75"
                min-width="75"
                @error="handleImageError()"
              >
              </v-img>
              <span v-else class="white--text display-1">{{
                persona.nombres.trim()[0] || "-"
              }}</span>
            </v-avatar>
          </v-card-text>
          <v-card-text class="mt-1 mb-0 pt-0 pb-0 text-xs-center">
            <h4 class="font-weight-bold blue--text m-0" style="font-size:1.1em">
              {{ persona.ap_paterno }} {{ persona.ap_materno }}
              {{ persona.nombres }}
            </h4>
            <!-- <h4 class="font-weight-light ma-0" style="font-size:1.1em">
              <b>C.I.:</b>{{ persona.nro_doc }}
            </h4> -->
            <table class="table-datos-personales">
              <tr v-for="dato in l_datos_personales" :key="dato.key">
                <td>
                  <v-btn dark small icon color="primary" outline>
                    <span class="material-symbols-outlined">
                      {{ dato.icon }}
                    </span>
                  </v-btn>
                </td>
                <td>
                  <span class="titulo-personal font-weight-bold blue--text">
                    {{ dato.label }}
                  </span>
                  <br />
                  <span class="subtitulo-personal">
                    {{ persona[dato.key] }}
                  </span>
                </td>
              </tr>
            </table>
          </v-card-text>
          <v-card-actions
            class="py-0"
            style="border-top:0.5px solid rgba(103, 135, 183,0.3)"
          >
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn icon slot="activator" @click="verDetallePersona()">
                <v-icon>fullscreen</v-icon>
              </v-btn>
              <span>Ver detalles</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-container>
  </section>
</template>

<script>
export default {
  // Variables iniciales
  props: ["persona", "campos_personales"],
  components: {},
  data() {
    return {
      dialog: false,
      loading: false,
      api_backend: process.env.API_URL.split("api/")[0],
      foto: null,
      l_datos_personales: [
        {
          icon: "badge",
          label: "Nro item",
          key: "nro_item"
        },
        {
          icon: "domain",
          label: "Unidad",
          key: "nombre_unidad"
        },
        {
          icon: "engineering",
          label: "Cargo",
          key: "cargo"
        },
        {
          icon: "assignment_ind",
          label: "Puesto",
          key: "puesto"
        },
        {
          icon: "badge",
          label: "C.I:",
          key: "nro_doc"
        }
      ]
    };
  },
  computed: {},
  created() {
    if (!!this.campos_personales && this.campos_personales.length > 0) {
      this.l_datos_personales = this.l_datos_personales.filter(ele =>
        this.campos_personales.includes(ele.key)
      );
    }
    if (this.persona.foto) {
      this.foto = this.api_backend + this.persona.foto;
    } else {
      this.foto = ""; //require("../../../../assets/images/camara.jpg");
    }
  },
  mounted() {
    this.dialog = true;
  },
  methods: {
    //Metodo para abrir dialog de detalle de activos
    verDetallePersona() {
      this.$bus.$emit("openDialogVerDatosPersona", this.persona);
    },
    handleImageError() {
      this.foto = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}
.contenedor-persona {
  line-height: 0.9;
  .contenedor-foto {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .table-datos-personales {
    text-align: left;
    td {
      .v-btn {
        margin: 0;
        span {
          font-size: 1.4rem !important;
        }
      }
      height: 10px !important;
      line-height: 0.8;
      .titulo-personal {
        font-size: 0.85rem;
      }
      .subtitulo-personal {
        font-size: 0.95rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reportes_lista_personal/components/ItemSliderComponent.vue